import { apiFetch } from "../utils/apiFetch";
import { API_BASE_ADMIN, STORAGE_KEYS } from "../config/vars";

export async function getMe() {
    try {
        const res = await apiFetch(`${API_BASE_ADMIN}/login/me`);
        if (!res.ok) return null;
        return res.json();
    } catch (_) {
        return null;
    }
}

export async function logout() {
    try {
        await apiFetch(`${API_BASE_ADMIN}/login/logout`, {
            method: "POST",
        });
    } catch (_) {
        // ignore network errors during logout
    } finally {
        try {
            localStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN);
        } catch (_) {
            // ignore
        }
    }
}
